
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TipService } from '../../../../core/service/mercado-pago/mercado-pago.service';
import { ResumenPedidoService } from '../resumen-pedido/service/resumen-pedido.service';
import { Store } from '@ngrx/store';
import { ShippingState } from '../../../../store/shipping/shipping.reducer';
import * as ShippingActions from '../../../../store/shipping/shipping.actions';

@Component({
  selector: 'detail-orden-checkout-propina-repartidor',
  imports: [FormsModule],
  templateUrl: './propina-repartidor.component.html',
  styleUrl: './propina-repartidor.component.css'
})
export class PropinaRepartidorComponent implements OnInit {
  tips = [10, 15, 20, 30, 40];
  selectedTip: number | null = null;
  customTip: number | null = null;
  showCustomInput = false;

  constructor(
    private tipService: TipService,
    private resumenPedidoService: ResumenPedidoService,
    private store: Store<{ shipping: ShippingState }>
  ) { }

  ngOnInit(): void {
    // Inicializar la propina desde el servicio (que ahora carga desde localStorage)
    const savedTip = this.resumenPedidoService.getTip();
    if (savedTip > 0) {
      // Buscar si la propina guardada coincide con alguna de las opciones predefinidas
      if (this.tips.includes(savedTip)) {
        this.selectedTip = savedTip;
      } else {
        // Si es una propina personalizada
        this.showCustomInput = true;
        this.customTip = savedTip;
        this.selectedTip = savedTip;
      }
    }
  }

  selectTip(tip: number): void {
    if (this.selectedTip === tip && !this.showCustomInput) {
      this.selectedTip = null;
      this.tipService.setTip(0);
      this.resumenPedidoService.setTip(0);
      this.store.dispatch(ShippingActions.setDeliveryTip({ tip: '0' }));
    } else {
      this.selectedTip = tip;
      this.showCustomInput = false;
      this.customTip = null;
      this.tipService.setTip(tip);
      this.resumenPedidoService.setTip(tip);
      this.store.dispatch(ShippingActions.setDeliveryTip({ tip: tip.toString() }));
    }
  }

  toggleCustomInput(): void {
    this.showCustomInput = !this.showCustomInput;
    if (!this.showCustomInput) {
      this.customTip = null;
      this.selectedTip = null;
      this.tipService.setTip(0);
      this.resumenPedidoService.setTip(0);
      this.store.dispatch(ShippingActions.setDeliveryTip({ tip: '0' }));
    } else {
      this.selectedTip = null;
    }
  }

  onCustomTipChange(): void {
    if (this.customTip && this.customTip > 0) {
      this.selectedTip = this.customTip;
      this.tipService.setTip(this.customTip);
      this.resumenPedidoService.setTip(this.customTip);
      this.store.dispatch(ShippingActions.setDeliveryTip({ tip: this.customTip.toString() }));
    } else {
      this.selectedTip = null;
      this.tipService.setTip(0);
      this.resumenPedidoService.setTip(0);
      this.store.dispatch(ShippingActions.setDeliveryTip({ tip: '0' }));
    }
  }
}
